export default __webpack_public_path__ + "static/media/secondary.063e0d093b82d87d093c8c0f10948e91.svg";